import { useMemo, useState } from "react";
import { formatDate, formatTime } from "@/utils/format/date-time";

export const useAppointmentDateTime = (methods, initialDate, initialTime) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);

    const selectedDateValue = useMemo(() => {
        return selectedDate ?? initialDate ?? new Date();
    }, [selectedDate, initialDate]);

    const selectedTimeValue = selectedTime ?? initialTime ?? null;

    const handleDateChange = (date) => {
        setSelectedDate(date);
        setSelectedTime(null);

        methods.setValue("date", formatDate(date), {
            shouldDirty: true,
        });

        methods.setValue("time", null, {
            shouldDirty: true,
        });
    };

    const handleTimeChange = (time) => {
        setSelectedTime(time);

        methods.setValue("time", formatTime(time), {
            shouldDirty: true,
            shouldValidate: true,
        });
    };

    return {
        selectedDate: selectedDateValue,
        selectedTime: selectedTimeValue,
        handleDateChange,
        handleTimeChange,
    };
};
